<template>
  <div id="login">
    <el-row>
      <el-col :xs="{span:16,offset:4}" :sm="{span:10,offset:7}" :md="{span:8,offset:8}" :lg="{span:6,offset:9}">
        <el-form :model="loginForm" ref="loginForm" status-icon>
          <h3 style="text-align:center;">ログイン</h3>
          <el-form-item prop="email" label="メールアドレス（ログインID）"
            :rules="[
              { required: true, message: 'メールアドレスを入力してください', trigger: 'blur' },
              { type: 'email', message: 'メールアドレスの形式が正しくありません', trigger: 'blur,change' }
            ]"
          >
            <el-input placeholder="メールアドレス" v-model="loginForm.email"></el-input>
          </el-form-item>
          <el-form-item prop="password" label="パスワード"
            :rules="{required: true, message: 'パスワードを入力してください', trigger: 'blur'}">
            <el-input type="password" name="password" placeholder="パスワード" v-model="loginForm.password"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button style="width:100%" type="primary" @click="login('loginForm')">ログイン</el-button>
            <div><el-button type="text" @click="$router.push('/resetpassword')">パスワードをお忘れの方はこちら</el-button></div>
          </el-form-item>
          <el-form-item align="center">
            <div class="info">アカウントをお持ちですか?</div>
            <el-button type="text" @click="$router.push('/signup')">新規登録</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'login',
  data () {
    return {
      loginForm: {
        email: '',
        password: ''
      }
    }
  },
  created () {
    console.log('created:login')
  },
  methods: {
    login (formName) {
      console.log(this.loginForm)
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var self = this
          this.$store.dispatch('User/login', {'email': this.loginForm.email, 'password': this.loginForm.password}).then(function (response) {
            if (!response.result) {
              self.errorMessage(response.message)
            } else {
              self.$router.push('/books')
            }
          })
        } else {
          console.log('error login')
          return false
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/04-pages/Login.vue